module.exports = __webpack_public_path__ + "assets/img/faspay_701.b4254ac5.png";